import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

function PageSkeleton() {
  return (
    <div aria-busy="true" className="space-y-10" role="status">
      <div>
        <Skeleton className="h-8 w-72" />
        <Skeleton className="mt-3 h-4 w-full max-w-md" />
      </div>
      {[3, 4].map((rows) => (
        <section className="space-y-3" key={rows}>
          <Skeleton className="h-4 w-32" />
          <div className="divide-border divide-y border-y">
            {Array.from({ length: rows }, (_, index) => (
              <div className="flex h-12 items-center gap-4" key={index}>
                <Skeleton className="h-4 w-48 max-w-full" />
                <Skeleton className="h-4 w-32 max-w-full" />
              </div>
            ))}
          </div>
        </section>
      ))}
      <span className="sr-only">Loading page</span>
    </div>
  );
}

/** Mirrors PortalLayout while the session and tenant are loading. */
export function PortalLayoutSkeleton() {
  return (
    <div className="portal bg-background flex h-full">
      <aside
        aria-hidden
        className="bg-sidebar hidden w-60 shrink-0 flex-col gap-0.5 border-r p-3 md:flex"
      >
        <Skeleton className="h-9 w-full" />
        <div className="mt-3 space-y-1">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-12 items-center gap-3 border-b px-4 md:px-6">
          <Skeleton className="size-7" />
          <Skeleton className="h-3.5 w-24" />
        </div>
        <div className="mx-auto w-full max-w-[1040px] px-4 pt-10 pb-24 md:px-10">
          <PageSkeleton />
        </div>
      </div>
    </div>
  );
}
